// Один кадр раскадровки (таймлайн шота, лента монтажа): готовый холст копируется в свой.
import { useEffect, useRef } from 'react'

/** Один кадр раскадровки: готовый холст копируется в свой. */
export default function FilmFrame({ frame, index }: { frame: HTMLCanvasElement | null; index: number }) {
	const ref = useRef<HTMLCanvasElement>(null)
	useEffect(() => {
		const c = ref.current
		if (!c || !frame) return
		c.width = frame.width
		c.height = frame.height
		c.getContext('2d')?.drawImage(frame, 0, 0)
	}, [frame])
	return (
		<span className={`sc-tl__frame${frame ? ' is-ready' : ''}`} style={{ animationDelay: `${index * 25}ms` }}>
			<canvas ref={ref} aria-hidden="true" />
		</span>
	)
}
